import React from "react";
import { useParams } from "react-router-dom";
import "./event-detail.css";
import {
  Countdown,
  Gallery,
  ScrollToTop,
  YoutubeFrame,
} from "../../components";
import { events } from "../../constants/data";

const EventDetail = () => {
  const { eventId } = useParams();
  //   console.log("eventId:", eventId);

  const ourEvents = events.find((event) => event.id === eventId);
  //   console.log("ourEventsOutput:", ourEvents);
  return (
    <>
      <section className="eventDetailSection">
        <div className="container">
          <div className="eventHeader hor">
            <div className="left ver flex">
              <div className="eventTitle">
                <h1>{ourEvents.title}</h1>
              </div>
            </div>
            <div className="right ver flex">
              <div className="imgWrapper">
                <img src={ourEvents.image} alt={ourEvents.title} />
              </div>
            </div>
          </div>
          <div className="eventDetail">
            <p>{ourEvents.details}</p>
          </div>
          <div className="eventVideo">
            <YoutubeFrame link={ourEvents.youtubeURL} />
          </div>
          <div className="eventPictures">
            <div className="header">
              <h3>Gallery</h3>
            </div>
            <Gallery galleryImages={ourEvents.pictures} />
          </div>
        </div>
      </section>
      <Countdown />
      <ScrollToTop />
    </>
  );
};

export default EventDetail;
